import { LoadingOutlined } from "@ant-design/icons";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, MenuItem } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { DatePicker, Form, Input, InputNumber, Select, Spin } from "antd";
import locale from "antd/es/date-picker/locale/fr_FR";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavContext } from "../../../../App";
import { CANAL_OPTIONS_STRINGS, DELAI_RESOLUTION_OPTIONS_STRINGS, RATE_OPTIONS } from "../../../../constants";
import Snackbars from "../../../../GlobalComponents/Alerts/Snackbars";
import GridContainer from "../../../../GlobalComponents/Grid/GridContainer";
import GridItem from "../../../../GlobalComponents/Grid/GridItem";
import FiltreIcon from "../../../../GlobalComponents/IconComponents/FiltreIcon";
import H5 from "../../../../GlobalComponents/TypoGraphy/H5";
import { Colors } from "../../../../GlobalComponents/Utility/Colors";
import { fetchChaines } from "../../../../ReduxTLK/features/Chaines/ChaineSlice";
import {
    fetchListPventesIntervenant,
    fetchPventes,
} from "../../../../ReduxTLK/features/Pointdeventes/PointdeventeSlice";
import {
    closeFilterBox,
    openFilterBox,
    resetFilter,
    resetFilterCounter,
    setFilterCounter,
    setFilterDraft,
    setFilterModel,
} from "../../../../ReduxTLK/features/SAV/FilterSlice";
import {
    array_machine,
    array_priorite,
    array_status,
} from "../../../../ReduxTLK/features/SAV/ticketList";
import { fetchFilteredTickets } from "../../../../ReduxTLK/features/SAV/TicketSlice";
import { ticketService } from "../../../../service/ticketService";
import RatiosCards from "../Ratios/RatiosCards";
import TicketBadges from "../TicketBadges/TicketBadges";
import "./Filter.css";

const layout = {
    labelCol: {
        span: 5,
    },
    wrapperCol: {
        span: 22,
    },
    size: "large",
};

const dateFormat = "MM-YYYY";
const { RangePicker } = DatePicker;

export default function Filter(props) {
    const { nbrsOfTickets, ratios, notes } = props

    const { TextArea } = Input;
    const fetchFiltredModel = useSelector((state) => state.filter.filterModel);

    const [open, setOpen] = useState(false);

    const [openErrorBox, setOpenErrorBox] = useState(false);
    const [message, setMessage] = useState("");
    const [date, setDate] = useState();
    const [openCalenderModal, setOpenCalenderModal] = useState(false);
    const [priorite, setPriorite] = useState();

    const [pVName, setPVName] = useState("");
    const today = dayjs();
    const dispatch = useDispatch();
    const context = React.useContext(NavContext);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [chaineId, setChaineId] = useState();
    const [pointVenteId, setPointDeVente] = useState();

    const [nbrePages, setNbrePages] = useState();
    const newTicketDraft = useSelector(
        (state) => state.draftNewTicket.newTicketDraft
    );
    // const intervenant = useSelector((state) => state.pointDeVente.pventesIntervenants)
    const chaines = useSelector((state) => state.chaine.chaines);
    // const pointDeVentes = useSelector((state) => state.pointDeVente.pventes)
    const [pointDeVentes, setPointDeVentes] = useState([]);
    const [intervenant, setIntervenant] = useState([]);
    const [selectedPointVenteIds, setSelectedPointVenteIds] = useState([]);

    const [assignees, setAssignees] = useState([]);

    const savedFilterCounter = useSelector((state) => state.filter.counter);
    const savedFilterForm = useSelector((state) => state.filter.filter);

    useEffect(() => {
        if (savedFilterForm) {
            const processedFormData = {
                ...savedFilterForm,
                dateCreation: savedFilterForm.dateCreation
                    ? savedFilterForm.dateCreation.map(dateString =>
                        dateString ? dayjs(dateString) : null
                    ).filter(date => date !== null)
                    : null
            };
            form.setFieldsValue(processedFormData);
        }
    }, []);

    useEffect(() => {
        dispatch(fetchChaines());
        // You may want to fetch assignees here as well
        // fetchAssignees();
    }, []);

    useEffect(() => {
        if (chaineId !== undefined && chaineId !== null) {
            dispatch(fetchPventes(chaineId))
                .then(unwrapResult)
                .then((res) => {
                    setPointDeVentes(res?.data?.data?.result);
                });
        }
    }, [chaineId]);

    const handleBadgeClick = (badge) => {

        const filter = {
            ...fetchFiltredModel.body,
        }

        if (badge.statut !== undefined && badge.statut !== null) {
            filter.statut = [badge.statut]
        } else {
            filter.statut = null
        }

        onFinish(filter)
    }

    const disabledDate = (current) => {
        return current && current > moment().endOf("month");
    };

    const resetForm = () => {
        dispatch(resetFilterCounter());
        form.resetFields();
        setPointDeVentes([]);
        setIntervenant([]);
        setLoading(true);
        dispatch(
            fetchFilteredTickets({
                paginationModel: {
                    page: 1,
                    pageSize: 12,
                    nbPage: null,
                },
                body: {
                    id: null,
                    chaineId: null,
                    pointVenteId: null,
                    statut: null,
                    equipement: null,
                    priorite: null,
                    intervenantId: null,
                    rate: null,
                    canal: null,
                    delaiRésolution: null,
                    idAssignee: null,
                    dateBegin: null,
                    dateEnd: null
                },
            })
        )
            .then(unwrapResult)
            .then((res) => {
                dispatch(
                    setFilterModel({
                        paginationModel: {
                            page: res?.data?.pagination?.currentPage,
                            pageSize: res?.data?.pagination?.pageSize,
                            nbPage: res?.data?.pagination?.nbPage,
                        },
                        body: {
                            id: null,
                            chaineId: null,
                            pointVenteId: null,
                            statut: null,
                            equipement: null,
                            priorite: null,
                            intervenantId: null,
                            rate: null,
                            canal: null,
                            delaiRésolution: null,
                            idAssignee: null,
                            dateBegin: null,
                            dateEnd: null
                        },
                    })
                );
                setNbrePages(res?.data?.pagination?.nbPage);
                props.setTicketList(res?.data?.result?.tickets);
                setLoading(false);
                props.setFilterOptions({
                    id: null,
                    chaineId: null,
                    pointVenteId: null,
                    statut: null,
                    equipement: null,
                    priorite: null,
                    intervenantId: null,
                    rate: null,
                    canal: null,
                    delaiRésolution: null,
                    idAssignee: null,
                    dateBegin: null,
                    dateEnd: null
                });
                props.setOpenFiltreBox(false);
                dispatch(closeFilterBox());
                dispatch(resetFilter());
            });
    };

    const [selectedDate, setSelectedDate] = useState([]);

    const handleDateChange = (dates) => {
        if (dates?.length === 2) {
            setSelectedDate(dates);
        } else if (dates?.length === 1) {
            setSelectedDate([dates[0], dates[0]]);
        } else {
            setSelectedDate([]);
        }
    };

    function countNonNullFields(obj) {
        let count = 0;
        for (let key in obj) {
            if (Array.isArray(obj[key]) && obj[key].length > 0) {
                count++;
            } else if (Array.isArray(obj[key]) && obj[key].length === 0) {
                continue;
            } else if (obj[key] !== null && obj[key] !== undefined) {
                count++;
            }
        }
        return count;
    }

    const onFinish = (values) => {
        setLoading(true);
        dispatch(setFilterDraft(values));
        dispatch(
            fetchFilteredTickets({
                paginationModel: {
                    page: 1,
                    pageSize: 12,
                    nbPage: null,
                },
                body: {
                    ...values,
                    dateBegin: props.dateBegin,
                    dateEnd: props.dateEnd,
                },
            })
        )
            .then(unwrapResult)
            .then((res) => {
                const nonNullFieldsCount = countNonNullFields({
                    ...values,
                });

                dispatch(setFilterCounter(nonNullFieldsCount));
                dispatch(
                    setFilterModel({
                        paginationModel: {
                            page: res?.data?.pagination?.currentPage,
                            pageSize: res?.data?.pagination?.pageSize,
                            nbPage: res?.data?.pagination?.nbPage,
                        },
                        body: {
                            ...values,
                            dateBegin: props.dateBegin,
                            dateEnd: props.dateEnd,
                        },
                    })
                );

                setNbrePages(res?.data?.pagination?.nbPage);
                props.setTicketList(res?.data?.result?.tickets);
                setLoading(false);
                props.setOpenFiltreBox(false);
                dispatch(closeFilterBox());
            });
    };

    const onValuesChange = (changedValues, allValues) => {
        props.setFilterOptions(allValues);
        const [key, value] = Object.entries(changedValues)[0];

        if (key === "dateCreation" && value !== undefined && value !== null) {
            // For month range, get start of month and end of month
            const startMonth = value[0]?.startOf("month").format("YYYY-MM-DD");
            const endMonth = value[1]?.endOf("month").format("YYYY-MM-DD");

            props.setDateBegin(startMonth);
            props.setDateEnd(endMonth);
        }

        if (key === "dateCreation" && (value === undefined || value === null)) {
            props.setDateBegin();
            props.setDateEnd();
        }

        if (key === "priorite") {
            setPriorite(value);
        }

        if (key === "chaineId" && value !== undefined && value !== null) {
            form.setFieldsValue({
                chaineId: value,
                pointVenteId: null,
                intervenantId: null,
            });

            setIntervenant([]);
            setChaineId(value);

            dispatch(fetchPventes(value))
                .then(unwrapResult)
                .then((res) => {
                    setPointDeVentes(res?.data?.data?.result);
                });
        }

        if (key === "chaineId" && (value === undefined || value === null)) {
            form.setFieldsValue({
                chaineId: null,
                pointVenteId: null,
                intervenantId: null,
            });
            setPointDeVentes([]);
            setIntervenant([]);
        }

        if (key === "pointVenteId" && (value !== undefined || value !== null)) {
            if (value?.length > 0) {
                dispatch(fetchListPventesIntervenant(value)).then((res) => {
                    setIntervenant(res?.payload?.data?.data?.result);
                });
            } else {
                setPointDeVentes([]);
                setIntervenant([]);
            }
        }
    };


    const handleFiltreClick = () => {
        if (props.openFiltreBox === true) {
            props.setOpenFiltreBox(false);
            dispatch(closeFilterBox());
        } else {
            props.setOpenFiltreBox(true);
            dispatch(openFilterBox());
        }
    };

    const handleExportExcel = () => {
        setLoading(true);
        ticketService.exportTicketsExcel(fetchFiltredModel.body).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", `export_ticket_${moment().format("DDMMYYYY_HHmmss")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch((error) => {
            setMessage("Une erreur est survenue lors de l'exportation.");
            setOpenErrorBox(true);
        }).finally(() =>
            setLoading(false)
        );
    }

    useEffect(() => {
        if (props.openFiltreBox === true) {
            dispatch(openFilterBox());
            props.fetchData({
                paginationModel: {
                    page: fetchFiltredModel?.paginationModel?.page,
                    pageSize: 8,
                    nbPage: null,
                },
                body: {
                    ...fetchFiltredModel.body,
                },
            });
        } else {
            dispatch(closeFilterBox());

            props.fetchData({
                paginationModel: {
                    page: fetchFiltredModel?.paginationModel?.page,
                    pageSize: 12,
                    nbPage: null,
                },
                body: {
                    ...fetchFiltredModel.body,
                },
            });
        }
    }, [props.openFiltreBox]);

    const validateIsInteger = (_, value) => {
        if (value && !Number.isInteger(value)) {
            return Promise.reject(new Error("Veuillez saisir un entier valide"));
        }
        return Promise.resolve();
    };

    const handleOpenCalenderModal = () => {
        setOpenCalenderModal(true);
    };

    const filterOption = (input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    return (
        <>
            <div className="filter-header">
                <div className="filter-header-content">
                    {savedFilterCounter > 0 ? (
                        <span className="filter-counter">
                            {savedFilterCounter} filtre(s) appliqué(s)
                        </span>
                    ) : (
                        <></>
                    )}
                    <div >
                        {ratios &&
                            <RatiosCards
                                ratios={ratios}
                                notes={notes}
                            />
                        }
                    </div>

                    <div className="filter-buttons-container">
                        <Button
                            onClick={handleExportExcel}
                            startIcon={<FileDownloadIcon />}
                            className="export-excel-button"
                            variant="outlined"
                        >
                            <span className="button-text">
                                Export Excel
                            </span>
                        </Button>
                        <Button
                            onClick={handleFiltreClick}
                            startIcon={<FiltreIcon />}
                            className="filter-toggle-button"
                            variant="outlined"
                        >
                            <span className="button-text">
                                Filtres
                            </span>
                        </Button>
                    </div>
                </div>
            </div>

            {props.openFiltreBox ? (
                <div className="filter-box-container">
                    <div className="filter-box-content">
                        <br />
                        <Form
                            {...layout}
                            form={form}
                            name="control-hooks-filter"
                            onValuesChange={onValuesChange}
                            onFinish={onFinish}
                        >
                            <GridContainer spacing={0.3}>
                                {/* Row 1 */}
                                <GridItem
                                    className="grid-item-first"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Référence"} requiredInput={false} />
                                    <Form.Item
                                        name="id"
                                        rules={[
                                            {
                                                max: 100,
                                                required: false,
                                                validator: validateIsInteger,
                                            },
                                        ]}
                                        className="form-item"
                                    >
                                        <InputNumber
                                            style={{ backgroundColor: "white", width: "100%" }}
                                        />
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Enterprise"} requiredInput={false} />
                                    <Form.Item
                                        name="chaineId"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            allowClear
                                            showSearch
                                            filterOption={filterOption}
                                            placeholder=""
                                        >
                                            {chaines &&
                                                chaines.map((chaine) => (
                                                    <option key={chaine.id} value={chaine.id}>
                                                        {chaine.nom}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Établissement"} requiredInput={false} />
                                    <Form.Item
                                        name="pointVenteId"
                                        rules={[
                                            {
                                                required: false,
                                                message: "Ce champ est obligatoire !",
                                            },
                                        ]}
                                        className="form-item"
                                    >
                                        <Select
                                            placeholder=""
                                            mode="multiple"
                                            showSearch
                                            filterOption={filterOption}
                                            maxTagCount="responsive"
                                        >
                                            {pointDeVentes &&
                                                pointDeVentes.map((pv) => (
                                                    <option key={pv.id} value={pv.id}>
                                                        {pv.nom}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Status"} requiredInput={false} />
                                    <Form.Item
                                        name="statut"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            placeholder=""
                                            mode="multiple"
                                            showSearch
                                            filterOption={filterOption}
                                            maxTagCount="responsive"
                                            sx={{ width: "100%" }}
                                        >
                                            {array_status &&
                                                array_status
                                                    .filter(
                                                        (item) =>
                                                            item.id !== 7 && item.id !== 5 && item.id !== 8
                                                    )
                                                    .map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.nom}
                                                        </option>
                                                    ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                {/* Row 2 */}
                                <GridItem
                                    className="grid-item-first"
                                    sm={6}
                                    md={3}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Equipement"} requiredInput={false} />
                                    <Form.Item
                                        name="equipement"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            placeholder=""
                                            mode="multiple"
                                            maxTagCount="responsive"
                                            showSearch
                                            filterOption={filterOption}
                                        >
                                            {array_machine &&
                                                array_machine.map((machine) => (
                                                    <option key={machine.id} value={machine.id}>
                                                        {machine.nom}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Priorité"} requiredInput={false} />
                                    <Form.Item
                                        name="priorite"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            mode="multiple"
                                            placeholder=""
                                            showSearch
                                            filterOption={filterOption}
                                            maxTagCount="responsive"
                                        >
                                            {array_priorite &&
                                                array_priorite.map((priorite) => (
                                                    <option key={priorite.id} value={priorite.id}>
                                                        {priorite.nom}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Intervenant"} requiredInput={false} />
                                    <Form.Item
                                        name="intervenantId"
                                        rules={[
                                            {
                                                required: false,
                                                message: "Ce champ est obligatoire !",
                                            },
                                        ]}
                                        className="form-item-intervenant"
                                    >
                                        <Select
                                            variant={"outlined"}
                                            mode="multiple"
                                            showSearch
                                            filterOption={filterOption}
                                            maxTagCount="responsive"
                                            required={true}
                                            className="intervenant-select"
                                            style={{ color: Colors.grey3 }}
                                        >
                                            {intervenant.map((option, index) => {
                                                return (
                                                    <MenuItem
                                                        key={index}
                                                        value={option.id}
                                                    >{`${option.nom} ${option.prenom}`}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Date"} requiredInput={false} />
                                    <Form.Item
                                        name="dateCreation"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <RangePicker
                                            allowClear
                                            disabledDate={disabledDate}
                                            picker="month"         
                                            size="middle"
                                            placeholder={["MM-YYYY", "MM-YYYY"]}
                                            locale={locale}
                                            onChange={handleDateChange}
                                            className="date-picker"
                                            format={dateFormat}        
                                        />
                                    </Form.Item>
                                </GridItem>

                                {/* Row 3 - New filters */}
                                <GridItem
                                    className="grid-item-first"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Note"} requiredInput={false} />
                                    <Form.Item
                                        name="rate"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            placeholder=""
                                            mode="multiple"
                                            maxTagCount="responsive"
                                            showSearch
                                            filterOption={filterOption}
                                        >
                                            {RATE_OPTIONS &&
                                                RATE_OPTIONS.map((rate) => (
                                                    <option key={rate.value} value={rate.value}>
                                                        {rate.label}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Canal"} requiredInput={false} />
                                    <Form.Item
                                        name="canal"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            placeholder=""
                                            mode="multiple"
                                            maxTagCount="responsive"
                                            showSearch
                                            filterOption={filterOption}
                                        >
                                            {CANAL_OPTIONS_STRINGS &&
                                                CANAL_OPTIONS_STRINGS.map((canal) => (
                                                    <option key={canal.value} value={canal.value}>
                                                        {canal.label}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>

                                <GridItem
                                    className="grid-item"
                                    sm={6}
                                    md={2.95}
                                    xl={2.95}
                                    xxl={2.95}
                                >
                                    <H5 title={"Estimation de la résolution"} requiredInput={false} />
                                    <Form.Item
                                        name="delaiRésolution"
                                        rules={[{ required: false }]}
                                        className="form-item"
                                    >
                                        <Select
                                            placeholder=""
                                            mode="multiple"
                                            maxTagCount="responsive"
                                            showSearch
                                            filterOption={filterOption}
                                        >
                                            {DELAI_RESOLUTION_OPTIONS_STRINGS &&
                                                DELAI_RESOLUTION_OPTIONS_STRINGS.map((delai) => (
                                                    <option key={delai.value} value={delai.value}>
                                                        {delai.label}
                                                    </option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </GridItem>
                            </GridContainer>

                            <Snackbars
                                severity={"success"}
                                message={message}
                                open={open}
                                setOpen={setOpen}
                                autohideduration={1000}
                            />
                            <Snackbars
                                severity={"error"}
                                message={message}
                                open={openErrorBox}
                                setOpen={setOpenErrorBox}
                                autohideduration={1000}
                            />

                            <br />

                            <div className="action-buttons-container">
                                <Button
                                    className="reset-button"
                                    variant="outlined"
                                    onClick={resetForm}
                                >
                                    Réinitialiser
                                </Button>
                                <Button
                                    className="confirm-button"
                                    type="submit"
                                    variant="contained"
                                >
                                    {loading ? (
                                        <div className="loading-center">
                                            <Spin
                                                indicator={
                                                    <LoadingOutlined
                                                        style={{ fontSize: 20, color: "white" }}
                                                        spin
                                                    />
                                                }
                                            />
                                        </div>
                                    ) : (
                                        "Confirmer"
                                    )}
                                </Button>
                            </div>

                            <br />
                        </Form>
                    </div>
                </div>
            ) : null}

            <div>
                <TicketBadges
                    nbrsOfTickets={nbrsOfTickets}
                    onBadgeClick={handleBadgeClick}
                />
            </div>
        </>
    );
}